import Cookies from "js-cookie";

export const AUTH_COOKIE_NAMES = [
  "refreshToken",
  "token",
  "company",
  "_id",
  "company_id",
];

export const clearAuthSession = () => {
  AUTH_COOKIE_NAMES.forEach((name) => {
    Cookies.remove(name);
    Cookies.remove(name, { path: "/" });
  });
};

export const redirectToLogin = () => {
  if (window.location.pathname === "/login") return;
  window.location.replace("/login");
};

export const clearAuthSessionAndRedirect = () => {
  clearAuthSession();
  redirectToLogin();
};

export const isAuthErrorMessage = (message) => {
  const normalized = `${message || ""}`.trim().toLowerCase();
  if (!normalized) return false;

  return [
    "e_jwt_token_expired",
    "e_invalid_jwt_token",
    "jwt expired",
    "jwt malformed",
    "invalid token",
    "authorization needed",
    "please login first",
    "unauthenticated",
    "not authenticated",
  ].some((keyword) => normalized.includes(keyword));
};
